import Loadable from 'react-loadable';

import React from 'react';

const AppZeroBoot = Loadable({
    loader: () => import('./App'),
    loading() {
        return <div style={{
            position: "absolute",
            display: "flex",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            alignContent: 'center',
            justifyContent: 'center',
            alignItems: 'center'
        }}>Loading...</div>
    }
});
export default AppZeroBoot
